import {Container, Nav, Navbar} from "react-bootstrap";
import {Link, useLocation} from "react-router-dom";

const TopNavBar = ({pageLoaded}) => {
    const location = useLocation();
    const bookingActive = location?.pathname === '/booking';
    const formActive = location?.pathname === '/contact';
    return (
        <Navbar collapseOnSelect expand="md">
            <Container fluid>
                <Navbar.Brand href="#home" className={'py-0 ps-4'}>
                    <img src="/logo512.png" alt="Logo" className={'nav-logo'}
                         style={{transform: (pageLoaded) ? 'none' : 'translateX(-140px)'}}/>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="ms-auto pe-lg-3">
                        <Link to={'/booking'}
                              className={`${bookingActive ? 'nav-link-custom-active' : ''} nav-link-custom`}>Buscar
                            Pasaje</Link>
                        <Link to={'/contact'}
                              className={`${formActive ? 'nav-link-custom-active' : ''} nav-link-custom`}>{`Contacto`}</Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}
export default TopNavBar;